import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  /**
   * Href attribute.
   */
  href: PropTypes.string,

  /**
   * Text displayed.
   */
  label: PropTypes.string.isRequired,

  /**
   * Title attribute.
   */
  title: PropTypes.string.isRequired,

  /**
   * CSS class.
   */
  className: PropTypes.string,

  /**
   * Function trigger on click event.
   */
  onClick: PropTypes.func.isRequired
};
var defaultProps = {
  className: null,
  href: '#'
};
/**
 * This component displays a simple a HTML element with an onclick attribute.
 */

var ActionLink =
/*@__PURE__*/
function (PureComponent) {
  function ActionLink() {
    PureComponent.apply(this, arguments);
  }

  if (PureComponent) ActionLink.__proto__ = PureComponent;
  ActionLink.prototype = Object.create(PureComponent && PureComponent.prototype);
  ActionLink.prototype.constructor = ActionLink;

  ActionLink.prototype.render = function render() {
    var ref = this.props;
    var href = ref.href;
    var label = ref.label;
    var title = ref.title;
    var className = ref.className;
    var _onClick = ref.onClick;
    return (// eslint-disable-next-line jsx-a11y/anchor-is-valid
      React.createElement('a', {
        href: href,
        title: title,
        'aria-label': title,
        className: className,
        onClick: function onClick(evt) {
          evt.preventDefault();
          evt.stopPropagation();

          _onClick(evt);
        }
      }, label)
    );
  };

  return ActionLink;
}(PureComponent);

ActionLink.propTypes = propTypes;
ActionLink.defaultProps = defaultProps;
export default ActionLink;